module.exports = __webpack_public_path__ + "img/video_play.fb17e8ed.svg";